<section
  class="px-4 bg-ayr-yellow-200 dark:bg-ayr-grey-1000 text-ayr-black dark:text-ayr-white"
>
  <div class="py-9 lg:max-w-960 m-auto">
    <h2 class="text-47 flex flex-wrap justify-center gap-x-2">
      <span>{{ "citizens.how-ayr-works.how" | translate }}</span>

      @if (!darkMode) {
        <img
          class="inline-block"
          src="https://storage.googleapis.com/weayr-assets-non-prod/svg/ayr-logo.svg"
          width="100px"
          height="40px"
          alt="Ayr logo"
          loading="lazy"
        />
      }

      @if (darkMode) {
        <img
          class="inline-block"
          src="https://storage.googleapis.com/weayr-assets-non-prod/images/sidebar/images/ayr-logo white.svg"
          width="100px"
          height="40px"
          alt="Ayr logo"
          loading="lazy"
        />
      }

      <span class="ayr-underline dark:text-shadow font-bold">
        {{ "citizens.how-ayr-works.works" | translate }}
      </span>
    </h2>

    <ul class="grid gap-12 justify-center lg:grid-cols-3 mt-6 lg:mt-0">
      <li class="max-w-[224px] lg:max-w-none">
        <p class="flex-grow lg:mt-5 text-center font-bold lg:text-21">
          {{ "citizens.pick-your-green" | translate }}
        </p>
      </li>
      <li class="max-w-[224px] lg:max-w-none">
        <p class="flex-grow lg:mt-5 text-center font-bold lg:text-21">
          {{ "citizens.receive-ayr-credit" | translate }}
        </p>
      </li>
      <li class="max-w-[224px] lg:max-w-none">
        <p class="flex-grow lg:mt-5 text-center font-bold lg:text-21">
          {{ "citizens.use-your-ayr" | translate }}
        </p>
      </li>
    </ul>
  </div>
</section>
